export default __webpack_public_path__ + "static/media/Wallpaper-3.963c7d7e.jpg";